module.exports = __webpack_public_path__ + "img/pg3_intelligence.8af7d409.png";